import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarMenuItems = _resolveComponent("NavBarMenuItems")!
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheFormBankInfo = _resolveComponent("TheFormBankInfo")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader, null, {
      "menu-list": _withCtx(() => [
        _createVNode(_component_NavBarMenuItems, { listItems: _ctx.ListItemsNavBarBankForm }, null, 8, ["listItems"])
      ]),
      _: 1
    }),
    _createVNode(_component_TheFormBankInfo, { imageFileName: "side-image-bank.jpg" }),
    _createVNode(_component_TheFooter)
  ], 64))
}